import { render } from "./index.vue?vue&type=template&id=7afa606f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7afa606f&lang=css"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__